import React from 'react'
import {Link} from 'react-router-dom'
import ResponsiveImg from '../../common/ResponsiveImg'
import Img01 from '../../../assets/imgs/host/what_carstay.png'
import Img01Dimension from '../../../assets/imgs/host/what_carstay.png?size'
import styles from './WhatIsCarstay.scss'

const WhatIsCarstay = () => <>
  <div className={[styles.container].join(' ')}>
    <div className={styles.space120}/>
    <div className="d-flex flex-column align-items-center">
      <div className={[styles.subTitle].join(' ')}>
        Carstayのスペースシェアサービス
      </div>
      <div className={[styles.descText].join(' ')}>
        Carstayは、キャンピングカーのレンタル・カーシェア、車中泊スポット・キャンプ場のスペースシェアサービスです。
        <br className='d-sm-block d-none'/>誰でもかんたんに、キャンプやVANLIFEを楽しむための車と場所を予約・登録することができます。
      </div>
    </div>
    <div className="d-lg-flex">
      <div className={['d-lg-block d-none mb-4 mb-md-0', styles.leftImage].join(' ')}>
        <ResponsiveImg
          width={479}
          height={319}
          url={Img01}
          caption="Img01"
        />
      </div>
      <div className={['d-lg-none d-block mb-4 mb-md-0', styles.leftImage].join(' ')}>
        <ResponsiveImg
          url={Img01}
          caption="Img01"
          srcSet={Img01}
          dimension={Img01Dimension}
        />
      </div>
      <div className={[styles.rightText].join(' ')}>
        <div className={[styles.titleView].join(' ')}>
          <div className={[styles.title].join(' ')}>使わない時に、使いたい人とシェアリング</div>
          <div>
            空き地・駐車場のオーナーであるホストが使わない時に、利用者したいゲストは
            <span className={styles.otherFont}>Carstay</span>を通じて車中泊スポット・キャンプ場として予約できます。
          </div>
        </div>
        <div className={[styles.titleView].join(' ')}>
          <div style={{marginTop: 23}} className={[styles.title].join(' ')}>スキルや空き時間もシェアできる</div>
              ホストは自身のスキルや空き時間を利用して、スポーツ・文化体験を提供することもできます。車中泊スポットの予約と組み合わせることで、収益UPも見込めます。
        </div>
        <div className={['d-lg-flex d-none justify-content-center p-3 bg-white border', styles.btnOutlineWhiteBook].join(' ')}>
          <Link to={'/usage/'}
            className={['text-decoration-none mx-1', styles.btnWhite].join(' ')}>
            ご利用ガイドを見る
          </Link>
        </div>
      </div>
    </div>
  </div>
  <div className={['d-flex d-block d-lg-none align-items-center justify-content-center p-3 bg-white border', styles.btnOutlineWhiteBook, styles.auto].join(' ')}>
    <Link to={'/usage/'}
      className={['text-decoration-none mx-1', styles.btnWhite].join(' ')}>
        ご利用ガイドを見る
    </Link>
  </div>
  <div className={styles.space147}/>
</>
WhatIsCarstay.displayName = 'WhatIsCarstay'
export default WhatIsCarstay
